import gql from 'graphql-tag';

const JobQuery = {
  sendCourierLandingPageEmail: gql`
    query sendCourierLandingPageEmail($phone: String!, $name: String!) {
      sendCourierLandingPageEmail(phone: $phone, name: $name) {
        success
        error
      }
    }
  `
};

export default JobQuery;
